 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-app-package":"admin-app-package","case-list~category-list~craft-colour~qa-category-list~qa-list":"case-list~category-list~craft-colour~qa-category-list~qa-list","category-list":"category-list","qa-category-list":"qa-category-list","chat-workbench":"chat-workbench","arrive-address~exception-403":"arrive-address~exception-403","arrive-address":"arrive-address","exception-403":"exception-403","case-edit~craft-colour~qa-edit":"case-edit~craft-colour~qa-edit","case-edit":"case-edit","qa-edit":"qa-edit","case-list":"case-list","craft-colour":"craft-colour","qa-list":"qa-list","customer-order-item":"customer-order-item","customer-order-item-craft-detail":"customer-order-item-craft-detail","customer-file":"customer-file","customer-list":"customer-list","customer-order":"customer-order","customer-order-follow":"customer-order-follow","express-list":"express-list","system-backup":"system-backup","customer-group":"customer-group","coupon-rule-list":"coupon-rule-list","customer-address":"customer-address","customer-coupon-list":"customer-coupon-list","exception-404":"exception-404","inquiry-list":"inquiry-list","login":"login","notification-list":"notification-list","open-token-list":"open-token-list"}[chunkId]||chunkId) + "." + {"admin-app-package":"af205fba","case-list~category-list~craft-colour~qa-category-list~qa-list":"74b85e26","category-list":"615b423f","qa-category-list":"0c08747b","chat-workbench":"60a0e8d0","chunk-01c59455":"7da22da4","arrive-address~exception-403":"649a8d6e","arrive-address":"21310f33","exception-403":"aa2d4a46","case-edit~craft-colour~qa-edit":"31beef5f","case-edit":"4e2a3b0d","qa-edit":"f2b16604","case-list":"ca729dc9","chunk-56dbafd0":"d90b96ef","craft-colour":"dec6fb88","qa-list":"d0b8c006","chunk-fd5baa14":"f8809fd7","customer-order-item":"f4097215","customer-order-item-craft-detail":"72bbf580","customer-file":"a8bdc1c5","customer-list":"e9362b9a","customer-order":"00c16ed8","customer-order-follow":"c32de42a","express-list":"94c61f66","system-backup":"a16f993d","chunk-4781fa7d":"f3b06f99","customer-group":"0854dcc6","coupon-rule-list":"90584eea","customer-address":"910f1959","customer-coupon-list":"273f6ab1","exception-404":"dfc36e90","inquiry-list":"7815b12e","login":"708584c1","notification-list":"cdfb2a07","open-token-list":"d4940039"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-app-package":1,"case-list~category-list~craft-colour~qa-category-list~qa-list":1,"category-list":1,"qa-category-list":1,"chat-workbench":1,"chunk-01c59455":1,"arrive-address~exception-403":1,"arrive-address":1,"exception-403":1,"case-edit~craft-colour~qa-edit":1,"case-edit":1,"qa-edit":1,"case-list":1,"craft-colour":1,"qa-list":1,"chunk-fd5baa14":1,"customer-order-item":1,"customer-order-item-craft-detail":1,"customer-file":1,"customer-list":1,"customer-order":1,"customer-order-follow":1,"express-list":1,"system-backup":1,"chunk-4781fa7d":1,"customer-group":1,"coupon-rule-list":1,"customer-address":1,"customer-coupon-list":1,"exception-404":1,"inquiry-list":1,"login":1,"notification-list":1,"open-token-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-app-package":"admin-app-package","case-list~category-list~craft-colour~qa-category-list~qa-list":"case-list~category-list~craft-colour~qa-category-list~qa-list","category-list":"category-list","qa-category-list":"qa-category-list","chat-workbench":"chat-workbench","arrive-address~exception-403":"arrive-address~exception-403","arrive-address":"arrive-address","exception-403":"exception-403","case-edit~craft-colour~qa-edit":"case-edit~craft-colour~qa-edit","case-edit":"case-edit","qa-edit":"qa-edit","case-list":"case-list","craft-colour":"craft-colour","qa-list":"qa-list","customer-order-item":"customer-order-item","customer-order-item-craft-detail":"customer-order-item-craft-detail","customer-file":"customer-file","customer-list":"customer-list","customer-order":"customer-order","customer-order-follow":"customer-order-follow","express-list":"express-list","system-backup":"system-backup","customer-group":"customer-group","coupon-rule-list":"coupon-rule-list","customer-address":"customer-address","customer-coupon-list":"customer-coupon-list","exception-404":"exception-404","inquiry-list":"inquiry-list","login":"login","notification-list":"notification-list","open-token-list":"open-token-list"}[chunkId]||chunkId) + "." + {"admin-app-package":"7b5475ba","case-list~category-list~craft-colour~qa-category-list~qa-list":"fae35b5a","category-list":"c9ecaf95","qa-category-list":"479f1dec","chat-workbench":"7bd525a6","chunk-01c59455":"a5bf9d58","arrive-address~exception-403":"8f90d322","arrive-address":"3845f3ab","exception-403":"80f92f65","case-edit~craft-colour~qa-edit":"92e4b531","case-edit":"7389adda","qa-edit":"0eb0b356","case-list":"cf430d3b","chunk-56dbafd0":"31d6cfe0","craft-colour":"ac8c89ad","qa-list":"b377b109","chunk-fd5baa14":"f91614ce","customer-order-item":"b85d266b","customer-order-item-craft-detail":"29a8064b","customer-file":"fc135885","customer-list":"7dac5d5e","customer-order":"f15dec5a","customer-order-follow":"9ea1ecc5","express-list":"1fdf045b","system-backup":"4dd257a0","chunk-4781fa7d":"0dd69e85","customer-group":"9d74b890","coupon-rule-list":"cffd70a7","customer-address":"c13783fe","customer-coupon-list":"4a9cce8e","exception-404":"38da3a36","inquiry-list":"05811e54","login":"3182090a","notification-list":"8389beb3","open-token-list":"4433d6e5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
